module.exports = __webpack_public_path__ + "img/男-肝癌h.8dba6e1a.png";